import { Empty } from "antd";
import { useTranslation } from "react-i18next";

export function ComingSoon() {
  const { t } = useTranslation();
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
      <Empty description={t("coming_soon")} />
    </div>
  );
}
